// pages/DevAccess.tsx
import React, { useState, useEffect } from "react";
// @ts-ignore
import Cookies from 'js-cookie';

const DEV_PASSWORD = "abachir";
const ALL_INTERFACES = ["caisse", "vendeur", "commandes" , "stock"];

const DevAccess = () => {
    const [password, setPassword] = useState("");
    const [authorized, setAuthorized] = useState(false);
    const [selectedInterfaces, setSelectedInterfaces] = useState<string[]>([]);

    useEffect(() => {
        const stored = Cookies.get("allowedInterfaces");
        if (stored) {
            try {
                setSelectedInterfaces(JSON.parse(stored));
            } catch {
                setSelectedInterfaces([]);
            }
        }
    }, []);

    const handlePasswordSubmit = (e: React.FormEvent) => {
        e.preventDefault();
        if (password === DEV_PASSWORD) {
            setAuthorized(true);
        } else {
            alert("mot de passe incorrect");
        }
    };

    const toggleInterface = (iface: string) => {
        const updated = selectedInterfaces.includes(iface)
            ? selectedInterfaces.filter((i) => i !== iface)
            : [...selectedInterfaces, iface];

        setSelectedInterfaces(updated);
        Cookies.set("allowedInterfaces", JSON.stringify(updated), { expires: 7 });
    };

    if (!authorized) {
        return (
            <div className="container mt-5">
                <h2>🔐 Entrez le mot de passe</h2>
                <form onSubmit={handlePasswordSubmit}>
                    <input
                        type="password"
                        value={password}
                        onChange={(e) => setPassword(e.target.value)}
                        placeholder="mot de passe"
                        className="form-control my-2"
                    />
                    <button className="btn btn-primary" type="submit">Entrez</button>
                </form>
            </div>
        );
    }

    return (
        <div className="container mt-5">
            <h2>✅ Interface Access Manager</h2>
            <ul className="list-group">
                {ALL_INTERFACES.map((iface) => (
                    <li className="list-group-item d-flex justify-content-between align-items-center" key={iface}>
                        {iface}
                        <input
                            type="checkbox"
                            checked={selectedInterfaces.includes(iface)}
                            onChange={() => toggleInterface(iface)}
                        />
                    </li>
                ))}
            </ul>
        </div>
    );
};

export default DevAccess;
